export default "__VITE_ASSET__Cx1Ks6hH__"